@if (dashItem.statNbDoc === true ||
  dashItem.statOldDoc === true ||
  dashItem.lastReq === true ||
  dashItem.statLoad === true ||
  dashItem.statView === true ||
  dashItem.statWork === true) {
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="grid">
        <div class="col-12">
          <i class="pi pi-cog cursorPointer" pTooltip="{{'Param' | translate}}" (click)="overpanel.toggle($event)"></i>
          {{'Mg_Dash' | translate}}
        </div>
      </div>
    </div>
    <p-overlayPanel #overpanel>
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6">
          @for (dashParamNew of dashParamNewTable; track dashParamNew; let idx = $index) {
            @if (idx < 5) {
              <div class="dd-box"
                [ngClass]="{
                    'backgrdred': dashParamNew.action === 'int' && isAdmin === true,
                    'backgrdblue': dashParamNew.action === 'wrk' && dashItem.statWork === true,
                    'backgrdgreen': dashParamNew.action === 'view' && dashItem.statView === true,
                    'backgrdyellow': dashParamNew.action === 'load' && dashItem.statLoad === true,
                    'backgrdorange': dashParamNew.action === 'old' && dashItem.statOldDoc === true,
                    'backgrdorchid': dashParamNew.action === 'em1' && dashItem.lastReq === true
                }"
                pDroppable="box" pDraggable="box"
                (onDrop)="drop($event, dashParamNew, idx)"
                (onDragStart)="dragStart($event,idx)" (onDragEnd)="dragEnd($event)"
                >
                {{dashParamNew.datapref.label}}
              </div>
            }
          }
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          @for (dashParamNew of dashParamNewTable; track dashParamNew; let idx = $index) {
            @if (idx > 4) {
              <div class="dd-box"
                [ngClass]="{
                    'backgrdred': dashParamNew.action === 'int' && isAdmin === true,
                    'backgrdblue': dashParamNew.action === 'wrk' && dashItem.statWork === true,
                    'backgrdgreen': dashParamNew.action === 'view' && dashItem.statView === true,
                    'backgrdyellow': dashParamNew.action === 'load' && dashItem.statLoad === true,
                    'backgrdorange': dashParamNew.action === 'old' && dashItem.statOldDoc === true,
                    'backgrdorchid': dashParamNew.action === 'em1' && dashItem.lastReq === true
                }"
                pDroppable="box" pDraggable="box"
                (onDrop)="drop($event, dashParamNew, idx)"
                (onDragStart)="dragStart($event,idx)" (onDragEnd)="dragEnd($event)"
                >
                {{dashParamNew.datapref.label}}
              </div>
              }
          }
        </div>
        <div class="col-12">
          <button class="right" type="text" pButton label="{{'Save' | translate}}" (click)="onClickEnter()"></button>
        </div>
      </div>
    </p-overlayPanel>
    <div class="col-12 md:col-6 lg:col-6">
      @for (dashConf of dashConfTable; track dashConf; let idx = $index) {
        @if (idx < 5) {
          <dashcontent [isAdmin]="isAdmin" [dashItem]="dashItem" [dashParam]="dashConf.action"></dashcontent>
        }
      }
    </div>
    <div class="col-12 md:col-6 lg:col-6">
      @for (dashConf of dashConfTable; track dashConf; let idx = $index) {
        @if (idx > 4) {
          <dashcontent [isAdmin]="isAdmin" [dashItem]="dashItem" [dashParam]="dashConf.action"></dashcontent>
        }
      }
    </div>
  </div>
}
